import { Radio, RadioChangeEvent, Row } from "antd";
import { IntervalSelector } from "../../IntervalSelector";
import { useMemo } from "react";
import { IOption } from "../../../../../types/Option";

type HeaderProps = {
  granularity: number;
  source: 1 | 2;
  setGranularity: React.Dispatch<React.SetStateAction<number>>;
  onSourceChange: (e: RadioChangeEvent) => void;
};

export const Header = ({
  granularity,
  source,
  setGranularity,
  onSourceChange,
}: HeaderProps) => {
  const options: IOption[] = useMemo(
    () => [
      { value: 1, label: "Payments" },
      { value: 2, label: "Disbursements" },
    ],
    [],
  );

  return (
    <Row className="w-100 justify-space-between">
      <p className="text my-0">Transaction Count by Method</p>
      <Row>
        <Radio.Group
          optionType="button"
          className="mr-2"
          options={options}
          value={source}
          onChange={onSourceChange}
          size="small"
        />
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
    </Row>
  );
};
